import { RequireAccess } from '@/components/require-access'
import { CandidateProfileSection } from '@/features/candidate-center-settings/candidate-profile-section'
import { SettingsHeading, SettingsNav } from '@/ui'
import { roleEnum } from '@jobilla/nexus-sdk'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/_auth/company/$companyId/settings/candidate-center')({
	component: RouteComponent,
})

function RouteComponent() {
	const { t } = useTranslation('common')

	return (
		<SettingsNav active="candidate-center">
			<SettingsHeading>{t('settings.candidateCenter.title')}</SettingsHeading>
			<RequireAccess
				role={[roleEnum.admin, roleEnum.jobillan]}
				fallback={<p className="text-red-600">{t('settings.candidateCenter.noPermission')}</p>}
			>
				<CandidateProfileSection />
			</RequireAccess>
		</SettingsNav>
	)
}
